.buttonsWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0;
}
